import * as React from 'react'

import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import EditIcon from '@material-ui/icons/Edit'
import FileDownloadIcon from '@material-ui/icons/FileDownload'
import AddIcon from '@material-ui/icons/Add'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { isAdmin } from '../../project-utils/permissions'
import { ActionButton, Back, Centered, Loader, PermissionGuard } from '../atoms'
import { DownloadExport } from '../organisms'
import { post, postFile } from '../../config'
import { FormattedMessage } from 'react-intl'
import getBase64 from '../../utils/base64'
import { downloadExcelFromB64 } from 'src/utils'
const renderDownloadButton = ({ loaded }) => {
  return (
    <>
      <Hidden xsDown>
        <ActionButton
          disabled={!loaded}
          color={'primary'}
          actionType={'downloadProcesses'}
          variant={'raised'}
        />
      </Hidden>
      <Hidden smUp>
        <Button
          disabled={!loaded}
          color={'primary'}
          variant={'raised'}
        >
          <FileDownloadIcon />
        </Button>
      </Hidden>
    </>
  )
}

interface ProgramBarProps {
  companiesFetching?: boolean
  onAddClick?: () => void
  exportRequest?: any
  programId: any
  onUpload?: () => void
}

interface MyState {
  isOpen: boolean
  isOpenCouples: boolean
}

class ProgramBar extends React.Component<ProgramBarProps, MyState> {
  public inputRef
  public inputRefCouples
  public onUpload
  constructor(props) {
    super(props)
    this.inputRef = React.createRef();
    this.inputRefCouples = React.createRef();
    this.state = {
      isOpen: false,
      isOpenCouples: false
    }
  }
  onButtonClick = () => {
    this.inputRef.current.click()

  }

  onButtonClickCouples = () => {
    this.inputRefCouples.current.click()

  }
  getFileName = () => {
    let fileName = ''
    for (let file of this.inputRef.current.files) {
      if (file) {
        fileName = file.name
      }
    }
    return fileName
  }

  getBase64FromFile = availableTo => () => {
    for (let file of this.inputRef.current.files) {
      if (file) {
        getBase64(file, this.uploadFile(availableTo))
      }
    }
  }

  uploadFile = availableTo => base64 => {
    post('/admin/upload', {
      base64: base64.result,
      programId: parseInt(this.props.programId),
      fileName: this.getFileName(),
      availableTo: availableTo
    })
      .then(data => this.handleClose())
      .catch(err => {
        console.error(err);
        this.handleClose()
      })
  }

  handleClickOpen = () => {
    this.setState({
      isOpen: true
    })
  }

  uploadFileCouples = (file) => {
    const formData = new FormData()
    formData.append('upfile', file, file.name)
    postFile('/v1/programs/' + parseInt(this.props.programId) + '/uploadProcesses', formData)
      .then(response =>
        response.json()
      )
      .then(data => {
        if (data.success === "false") {
          downloadExcelFromB64(data.file)
        }
        this.handleCloseCouples();
        this.inputRef.current.value = "";
        this.onUpload()
      })
      .catch(err => {
        console.error(err);
      })
  }

  getFile = () => {
    for (let file of this.inputRefCouples.current.files) {
      if (file) {
        this.uploadFileCouples(file)
      }
    }
  }

  handleClickOpenCouples = () => {
    this.getFile()
    this.setState({
      isOpenCouples: true
    })
  }

  handleCloseCouples = () => {
    this.setState({
      isOpenCouples: false
    })
  }

  handleClose = () => {
    this.setState({
      isOpen: false
    })
  }

  render() {
    const {
      onAddClick,
      exportRequest,
      onUpload
    } = this.props
    const { isOpen, isOpenCouples } = this.state
    this.onUpload = onUpload
    return (
      <Grid
        container
        justify={'space-between'}
        alignItems={'center'}
        spacing={24}
      >
        <Grid item>
          <Back />
        </Grid>
        <PermissionGuard check={isAdmin}>
          <Grid item>
            <Grid container spacing={16}>
              <Grid item>
                <Hidden xsDown>
                  <ActionButton
                    color={'secondary'}
                    onClick={this.onButtonClick}
                    actionType={'up'}
                    variant={'raised'}
                    id="file"
                  >
                    <input
                      type='file'
                      id="file"
                      ref={this.inputRef}
                      style={{ display: 'none' }}
                      onChange={this.handleClickOpen}
                    />
                  </ActionButton>
                </Hidden>
                <Hidden smUp>
                  <Button
                    color={'secondary'}
                    variant={'raised'}
                  >
                    <input
                      type='file'
                      id="file"
                      ref={this.inputRef}
                      style={{ display: 'none' }}
                      onChange={this.handleClickOpen}
                    />
                    <AddIcon />
                  </Button>
                </Hidden>
                {
                  isOpen && this.inputRef.current.files[0] !== undefined &&
                  <Dialog
                    open={isOpen}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        <FormattedMessage id={'dialog.text'} />
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={this.handleClose}>
                        <FormattedMessage id={'buttonActions.cancel'} />
                      </Button>
                      <Button onClick={this.getBase64FromFile('mentor')} color="primary" autoFocus>
                        <FormattedMessage id={'button.continue.mentor'} />
                      </Button>
                      <Button onClick={this.getBase64FromFile('mentee')} color="primary" autoFocus>
                        <FormattedMessage id={'button.continue.mentee'} />
                      </Button>
                      <Button onClick={this.getBase64FromFile('all')} color="primary" autoFocus>
                        <FormattedMessage id={'button.continue.all'} />
                      </Button>
                    </DialogActions>
                  </Dialog>
                }
              </Grid>
              <Grid item>
                <DownloadExport
                  fileName={'processes.xlsx'}
                  fileRequest={exportRequest}
                >
                  {renderDownloadButton}
                </DownloadExport>
              </Grid>
              <Grid item>
                <Hidden xsDown>
                  <ActionButton
                    onClick={onAddClick}
                    actionType={'edit'}
                    color={'primary'}
                    variant={'raised'}
                  />
                </Hidden>
                <Hidden smUp>
                  <Button
                    onClick={onAddClick}
                    color={'primary'}
                    variant={'raised'}
                  >
                    <EditIcon />
                  </Button>
                </Hidden>
              </Grid>
              <PermissionGuard check={isAdmin}>
                <Grid item>
                  <Grid container spacing={16}>
                    <Grid item>
                      <Hidden xsDown>
                        <ActionButton
                          color={'secondary'}
                          onClick={this.onButtonClickCouples}
                          actionType={'upCouplesFile'}
                          variant={'raised'}
                          id="fileCouples"
                        >
                          <input
                            type='file'
                            id="fileCouples"
                            ref={this.inputRefCouples}
                            style={{ display: 'none' }}
                            onChange={this.handleClickOpenCouples}
                          />
                        </ActionButton>
                      </Hidden>
                      <Hidden smUp>
                        <Button
                          color={'secondary'}
                          variant={'raised'}
                        >
                          <input
                            type='file'
                            id="fileCouples"
                            ref={this.inputRefCouples}
                            style={{ display: 'none' }}
                            onChange={this.handleClickOpenCouples}
                          />
                          <AddIcon />
                        </Button>
                      </Hidden>
                      {
                        isOpenCouples && this.inputRefCouples.current.files[0] !== undefined &&
                        <Dialog
                          open={isOpenCouples}
                          onClose={this.handleCloseCouples}
                          aria-labelledby="alert-dialog-title"
                          aria-describedby="alert-dialog-description"
                        >
                          <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                              <FormattedMessage id={'dialog.UpMMFile'} />
                            </DialogContentText>
                            <Centered horizontally fullWidth>
                              <Loader />
                            </Centered>
                          </DialogContent>
                        </Dialog>
                      }
                    </Grid>
                  </Grid>
                </Grid>
              </PermissionGuard>
            </Grid>
          </Grid>
        </PermissionGuard>
      </Grid>
    )
  }
}

export default ProgramBar



// WEBPACK FOOTER //
// ./src/components/molecules/ProgramBar.tsx